import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface MarketplaceScheduleTemporaryStopSyncStockRequestParams {
  shopId: number;
  marketplaceName: string;
  fromDate: string | undefined;
  untilDate: string;
}

export class MarketplaceClient {
  constructor(private httpClient: HTTPClient) {}

  public async postMarketplaceScheduleTemporaryStopSyncStock(
    params: MarketplaceScheduleTemporaryStopSyncStockRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/marketplaces/schedule-temporary-stop-sync-stock",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getMarketplaceScheduleTemporaryStopSyncStock(
    params: PaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/marketplaces/schedule-temporary-stop-sync-stock",
      method: "GET",
      params
    });

    return data;
  }
}
